import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

interface Props {
  title: string;
  children: React.ReactNode;
}

function SupportCard({ title, children }: Props) {
  const classes = useStyles();

  return (
    <Paper elevation={2} className={classes.root}>
      <div className={classes.titleContainer}>
        <Typography className={classes.title}>{title}</Typography>
      </div>
      {children}
    </Paper>
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    width: 442,
    height: 309,
    padding: theme.spacing(2.5),
    paddingTop: theme.spacing(3),
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: theme.spacing(2),
  },
  title: {
    // @ts-ignore
    ...theme.typography.h5Semibold,
  },
}));

export default SupportCard;
